// src/pages/Home.js
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Home() {
  const { currentUser, userRole, getRedirectPath } = useAuth();
  const navigate = useNavigate();
  
  // Redirect authenticated users to appropriate dashboard
  useEffect(() => {
    if (currentUser && userRole) {
      const redirectPath = getRedirectPath(userRole);
      console.log(`Home: User with role ${userRole} detected, redirecting to ${redirectPath}`);
      navigate(redirectPath);
    }
  }, [currentUser, userRole, navigate, getRedirectPath]);
  
  return (
    <div className="home-container">
      <div className="home-content">
        <h1>Learning Portfolio Platform</h1>
        <p>A place for learners to submit assignments and receive feedback from mentors.</p>
        
        {currentUser ? (
          <div className="dashboard-link">
            <div className="role-info" style={{
              padding: '10px',
              margin: '15px 0',
              border: '1px solid #ccc',
              backgroundColor: '#f9f9f9'
            }}>
              <h3>User Information</h3>
              <p><strong>Email:</strong> {currentUser.email}</p>
              <p><strong>Role:</strong> {userRole || 'Not assigned'}</p>
              <p><strong>UID:</strong> {currentUser.uid}</p>
            </div>
            
            <p>You should be redirected to your dashboard automatically.</p>
            <p>If not, use one of the links below:</p>
            
            <div style={{marginTop: '15px'}}>
              <Link to="/admin" className="btn btn-primary" style={{marginRight: '10px'}}>
                Admin Dashboard
              </Link>
              <Link to="/mentor" className="btn btn-primary" style={{marginRight: '10px'}}>
                Mentor Dashboard
              </Link>
              <Link to="/learner" className="btn btn-primary">
                Learner Dashboard
              </Link>
            </div>
          </div>
        ) : (
          <div className="auth-links">
            <Link to="/login" className="btn btn-primary">Login</Link>
            {/* Registration link removed */}
            <p className="info-text" style={{
              marginTop: '15px',
              fontSize: '0.9rem',
              color: '#666'
            }}>
              New accounts are created by administrators. Please contact your administrator for access.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;